import {
  HtmlLogo,
  CssLogo,
  JavascriptLogo,
  ReactLogo,
  NodeLogo,
  ExpressLogo,
} from '../assets/images/skills';

export const technosList = [
  {
    id: '1',
    name: 'HTML',
    picture: HtmlLogo,
  },
  {
    id: '2',
    name: 'CSS',
    picture: CssLogo,
  },
  {
    id: '3',
    name: 'Javascript',
    picture: JavascriptLogo,
  },
  {
    id: '4',
    name: 'React.js',
    picture: ReactLogo,
  },
  {
    id: '5',
    name: 'Node.js',
    picture: NodeLogo,
  },
  {
    id: '6',
    name: 'Express.js',
    picture: ExpressLogo,
  },
];
